import { useScroll } from "framer-motion";
import React, { useState } from "react";
import ButtonIconH from "../../components/ButtonIconH";
import InputData from "../../components/InputData";
import { userData } from "../../js/utils";
import { post } from "../utils/api";

import "../css/ResetPassword.css";

const tokenSesion = userData ? userData.token : "";

export default function ResetPasswordScreen(props) {
  const [userId, setUserId] = useState(props.userId);
  const [password, setPassword] = useState("");
  const [passwordRepeated, setPasswordRepeated] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordRepeated, setShowPasswordRepeated] = useState(false);

  const saveUserPassword = async () => {
    if (!minimunData()) {
      props.createPopupQuestion(
        `Los campos con (*) son obligatorios.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
    } else if (!checkPasswordOk()) {
      props.createPopupQuestion(
        `Las contraseñas introducidas no coinciden.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
    } else {
      let json_query = {
        token: tokenSesion,
        idAgente: props.userId,
        password: password,
      };

      let json_response = await post(
        "Configuracion/RestablecerPasswordAgente.php",
        json_query,
      );

      if (json_response) {
        let error = json_response.error;

        if (error === "OK") {
          return true;
        } else if (error !== "") {
          props.createPopupQuestion(
            error,
            props.removePopupQuestion,
            null,
            "Entendido",
          );
          return false;
        }
      }
    }
  };

  const hasChanges = () => {
    return password !== "" || passwordRepeated !== "";
  };

  const minimunData = () => {
    return password !== "" && passwordRepeated !== "";
  };

  const checkPasswordOk = () => {
    return password === passwordRepeated;
  };

  const handleClose = () => {
    if (hasChanges()) {
      props.createPopupQuestion(
        `Hay cambios sin guardar. ¿Seguro que quieres salir sin guardar?`,
        async () => {
          props.removePopupQuestion();
          props.closeFunction();
        },
        props.removePopupQuestion,
        "Sí",
        "No",
      );
    } else {
      props.closeFunction();
    }
  };

  if (!props.show) return <></>;

  return (
    <div className="rp-popup-container">
      <div className="rp-popup-screen">
        <div className="rp-popup-screen-header">
          <button className="popup-action-icon close-icon">
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt="Icon"
              onClick={() => {
                handleClose();
              }}
            ></img>
          </button>
          <span className="popup-screen-header-title">
            Restablecer contraseña
          </span>
        </div>
        <div className="rp-section-content">
          <div className="rp-data-field d-user-large">
            <span className="label">Nueva contraseña (*)</span>
            <InputData
              tabIndex={101}
              id="password"
              type={showPassword ? "text" : "password"}
              dontForceUppercase={true}
              size={6}
              input={password}
              onChange={(e) => {
                setPassword(e);
              }}
              icon={
                showPassword
                  ? "/images/no-eye-passwd.png"
                  : "/images/eye-passwd.png"
              }
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            />
          </div>
          <div className="rp-data-field d-user-large">
            <span className="label">Confirmar contraseña (*)</span>
            <InputData
              tabIndex={102}
              id="passwordRep"
              type={showPasswordRepeated ? "text" : "password"}
              dontForceUppercase={true}
              size={6}
              input={passwordRepeated}
              onChange={(e) => {
                setPasswordRepeated(e);
              }}
              icon={
                showPasswordRepeated
                  ? "/images/no-eye-passwd.png"
                  : "/images/eye-passwd.png"
              }
              onClick={() => {
                setShowPasswordRepeated(!showPasswordRepeated);
              }}
            />
          </div>
        </div>
        <div className="popup-row-buttons-container">
          <div className="popup-row-buttons profile-menu">
            <ButtonIconH
              text="Cancelar"
              onClick={() => {
                handleClose();
              }}
            />
            <ButtonIconH
              text="Guardar"
              onClick={() => {
                props.createPopupQuestion(
                  `¿Desea cambiar la contraseña para el agente actual?`,
                  async () => {
                    const guardadoExitoso = await saveUserPassword();

                    if (guardadoExitoso) {
                      props.removePopupQuestion();
                      props.closeFunction();
                    }
                  },
                  props.removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
